/**
 * A particular size at which a control should be rendered.
 */
export enum ActionControlSize {
  /** The size for a stacked control. Up to 3 controls can be stacked into a column in the MLR */
  Small = "Small",
  /** The size for a full-height control in the MLR */
  Large = "Large",
}
